var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"update-data-page"}},[_c('h2',{staticClass:"intro-y text-lg font-medium mt-10"},[_vm._v(" 更改會議室及資源項目 ")]),(_vm.mounted && _vm.checkPermission(_vm.permissions, 'site.resource.edit'))?_c('resource-form',{attrs:{"all-sites":_vm.allSites,"site":_vm.currentSite,"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }